import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

/**
 * The Damage chart tab body (SWOOP-254, WOW 3), rendered inside the work-order page layout at
 * `/work-orders/$workOrderId/damage-chart`. Permission / module gating is inherited from the layout
 * route's `beforeLoad`. The tab itself is offered only on Damage work orders (NOT_SCHEDULED / DAMAGE);
 * the page body redirects to the General tab when a non-damage work order lands on this URL.
 */
export const Route = createFileRoute('/_authenticated/work-orders_/$workOrderId/damage-chart')({
  component: lazyRouteComponent(() => import('&/features/work-orders/pages/work-order-damage-chart-tab')),
  staticData: { titleKey: 'workOrderDamageChart' },
});
